const apiUrl = "https://www.ymytpx.com/api/";
// const apiUrl = "http://127.0.0.1:8080/api/";
export default {
  apiUrl
};



// WEBPACK FOOTER //
// ./src/global/global.js